import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsDocumentsCardApi extends ComponentAPI<any> {

  @AwesomeEvent
  onAfterSubmitDocumentsCard = new ClickEventListener();

  @AwesomeEvent
  onMountDocumentsCard = new ClickEventListener();

}
